module.exports = __webpack_public_path__ + "img/facebookLogo.e2d82b5b.svg";